// extracted by mini-css-extract-plugin
export default {"text":"ListItem_text__RgJ1r","subtext":"ListItem_subtext__Pe6Pt","item":"ListItem_item__bP06E"};